import styled from 'styled-components';
import { v2Colors, v2FontFamily } from './styles/tokens';

export const SurfaceCard = styled.div`
  width: 100%;
  margin-top: 10px;
  padding: 18px;
  background: ${v2Colors.inputBackground};
  border: 1px solid ${v2Colors.border};
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(16, 24, 40, 0.08);
`;

export const SurfaceCardHeading = styled.p`
  margin: 0;
  font-family: ${v2FontFamily};
  font-size: 16px;
  font-weight: 700;
  color: ${v2Colors.text};
`;

export const SurfaceCardCloseButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(16, 24, 40, 0.07);
  color: ${v2Colors.textMuted};
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;

  svg {
    width: 14px;
    height: 14px;
    display: block;
  }

  &:hover,
  &:focus-visible {
    background: ${v2Colors.dangerSoft};
    color: ${v2Colors.danger};
  }
`;

// A SurfaceCard's header reads as a colored title bar — brand green,
// pulled out to the card's own edges (negative margin cancels the card's
// padding) and rounded to match its top corners. SurfaceCardHeading/
// SurfaceCardCloseButton keep their own default (dark-on-white) styling for
// every other use — e.g. the plain "Informativa Privacy" section heading,
// which isn't wrapped in a SurfaceCardHeader — so the white-on-green
// override only applies to instances nested inside this header.
export const SurfaceCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: -18px -18px 16px;
  padding: 14px 18px;
  background: ${v2Colors.primary};
  border-radius: 13px 13px 0 0;

  ${SurfaceCardHeading} {
    color: #ffffff;
  }

  ${SurfaceCardCloseButton} {
    background: rgba(255, 255, 255, 0.18);
    color: #ffffff;
  }

  ${SurfaceCardCloseButton}:hover,
  ${SurfaceCardCloseButton}:focus-visible {
    background: #ffffff;
    color: ${v2Colors.danger};
  }
`;
